import { AbstractTile } from "@/components/design/AbstractTile";

type TileVariant = "dots" | "lines" | "grid" | "rings" | "block";

// Artwork surface for a Grow catalogue tile and for the header of a group
// overview. Editorial artwork is shown sharp and format-filling - an editor who
// uploads a motif has to recognise it - so this is deliberately not the blurred
// ambient treatment the tiles used to carry. genesis serves the `card` variant at
// max height 140 and it is upscaled here, which is the same quality trade /share
// already makes; flat motifs work, fine detail and text in the image do not.
//
// Without artwork it falls back to the AbstractTile. The hue is the caller's job:
// it is derived from the group id so a group keeps its colour across loads.
export function TileArtwork({
  imageSrc,
  hue,
  variant,
  className,
}: {
  imageSrc?: string;
  hue: number;
  variant: TileVariant;
  className?: string;
}) {
  if (!imageSrc) {
    return <AbstractTile variant={variant} hue={hue} className={className} />;
  }
  return (
    <div className={`relative overflow-hidden ${className ?? ""}`}>
      <img src={imageSrc} alt="" className="absolute inset-0 h-full w-full object-cover" />
    </div>
  );
}
